/* Copyright (c) 2022 Xperi. All Rights Reserved. */

export class ScreenControllerTypes {
    public static readonly ACCOUNT_SCREEN = 'ACCOUNT_SCREEN';

    public static readonly ANTIBURN_SCREEN = 'ANTIBURN_SCREEN';

    public static readonly CLOUD_DVR_HELP_SCREEN = 'CLOUD_DVR_HELP_SCREEN';

    public static readonly COLLECTION_SCREEN = 'COLLECTION_SCREEN';

    public static readonly EMPTY_GUIDE_SCREEN = 'EMPTY_GUIDE_SCREEN';

    public static readonly FILTERED_GUIDE_SCREEN = 'FILTERED_GUIDE_SCREEN';

    public static readonly EMPTY_FILTERED_GUIDE_SCREEN = 'EMPTY_FILTERED_GUIDE_SCREEN';

    public static readonly ERROR_SCREEN = 'ERROR_SCREEN';

    public static readonly GALLERY_SCREEN = 'GALLERY_SCREEN';

    public static readonly GUIDE = 'GUIDE';

    public static readonly HELP_SCREEN = 'HELP_SCREEN';

    public static readonly INFO_SCREEN = 'INFO_SCREEN';

    public static readonly INFO_CARD_SCREEN = 'INFO_CARD_SCREEN';

    public static readonly MENU_LANGUAGE_SCREEN = 'MENU_LANGUAGE_SCREEN';

    public static readonly MAIN_SETTINGS_SCREEN = 'MAIN_SETTINGS_SCREEN';

    public static readonly MY_SHOWS_OPTIONS_MENU_SCREEN = 'MY_SHOWS_OPTIONS_MENU_SCREEN';

    public static readonly MY_SHOWS_SCREEN = 'MY_SHOWS_SCREEN';

    public static readonly LIST_VIEW_SCREEN = 'LIST_VIEW_SCREEN';

    public static readonly ONEPASS_MANAGER_SCREEN = 'ONEPASS_MANAGER_SCREEN';

    public static readonly ONEPASS_AND_RECORDINGS_MENU_SCREEN =
        'ONEPASS_AND_RECORDINGS_MENU_SCREEN';

    public static readonly PC_HIDE_ADULT_CONTENT_SCREEN = 'PC_HIDE_ADULT_CONTENT_SCREEN';

    public static readonly PC_SCREEN = 'PC_SCREEN';

    public static readonly PC_HELP_SCREEN = 'PC_HELP_SCREEN';

    public static readonly PC_HELP_SCREEN_OPTION = 'PC_HELP_SCREEN_OPTION';

    public static readonly PC_SET_RATING_LIMITS_SCREEN = 'PC_SET_RATING_LIMITS_SCREEN';

    public static readonly PROGRAM_SCREEN = 'PROGRAM_SCREEN';

    public static readonly SETTINGS_SCREEN = 'SETTINGS_SCREEN';

    public static readonly SIDEBAR_NAVIGATION_MENU_SCREEN = 'SIDEBAR_NAVIGATION_MENU_SCREEN';

    public static readonly SIGN_IN_SCREEN = 'SIGN_IN_SCREEN';

    public static readonly SOS_SCREEN = 'SOS_SCREEN';

    public static readonly SPLASH_SCREEN = 'SPLASH_SCREEN';

    public static readonly USER_PREFERENCES_SCREEN = 'USER_PREFERENCES_SCREEN';

    public static readonly USER_PREF_AUTOPLAY_NEXT_EPISODE_SCREEN =
        'USER_PREF_AUTOPLAY_NEXT_EPISODE_SCREEN';

    public static readonly USER_PREF_VIDEO_WINDOW_SCREEN = 'USER_PREF_VIDEO_WINDOW_SCREEN';

    public static readonly VIDEO_PLAYER = 'VIDEO_PLAYER';

    public static readonly VOD_BROWSE_MAIN_SCREEN = 'VOD_BROWSE_MAIN_SCREEN';

    public static readonly MANAGE_SCREEN = 'MANAGE_SCREEN';

    public static readonly TODO_LIST_SCREEN = 'TODO_LIST_SCREEN';

    public static readonly EMPTY_TODO_LIST_SCREEN = 'EMPTY_TODO_LIST_SCREEN';

    public static readonly RECORDING_ACTIVITY_SCREEN = 'RECORDING_ACTIVITY_SCREEN';

    public static readonly EMPTY_RECORDING_ACTIVITY_SCREEN = 'EMPTY_RECORDING_ACTIVITY_SCREEN';
}
